module.exports = __webpack_public_path__ + "img/ic-logo-paypal.5f01d37b.svg";